export default __webpack_public_path__ + "static/media/2200.772c49c6.png";